'use strict';

var _internals$dynamicRol;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var internals = {};

internals.calculate = function (user) {
    var list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];


    var usersGroups = user.groups || [];

    var _loop = function _loop(_ref) {
        var id = _ref.id;


        if (id === user.id || usersGroups.some(function (group) {
            return group.id === id;
        })) {

            return {
                v: true
            };
        }
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref = _step.value;

            var _ret = _loop(_ref);

            if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return false;
};

var RBAC = function () {
    function RBAC() {
        _classCallCheck(this, RBAC);
    }

    _createClass(RBAC, null, [{
        key: 'getDynamicRolesForUser',
        value: function getDynamicRolesForUser(user, asset) {

            return Object.entries(internals.dynamicRoles).reduce(function (acc, _ref2) {
                var _ref3 = _slicedToArray(_ref2, 2),
                    role = _ref3[0],
                    condition = _ref3[1];

                if (condition(user, asset)) {

                    return [].concat(_toConsumableArray(acc), [role]);
                }

                return acc;
            }, []);
        }
    }, {
        key: 'getStaticRolesForUser',
        value: function getStaticRolesForUser(user) {

            return user.roles || [];
        }
    }, {
        key: 'getRolesForUser',
        value: function getRolesForUser(user, asset) {

            return [].concat(_toConsumableArray(RBAC.getDynamicRolesForUser(user, asset)), _toConsumableArray(RBAC.getStaticRolesForUser(user)));
        }
    }, {
        key: 'can',
        value: function can(userRoles, roles) {

            if (roles.length === 0) {
                // No roles defined on ressource or user so

                return true;
            }

            if (!userRoles) {
                // no roles given so isn't allowed as there are roles required
                return false;
            }

            if (userRoles.length === 0) {
                // User has no roles so isn't allowed as there are roles required

                return false;
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = roles[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var role = _step2.value;


                    var isArray = Array.isArray(role);

                    if (isArray && role.every(function (r) {
                        return userRoles.includes(r);
                    }) || !isArray && userRoles.includes(role)) {

                        return true;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return false;
        }
    }, {
        key: 'roles',
        get: function get() {

            return [].concat(_toConsumableArray(RBAC.staticRoles), _toConsumableArray(RBAC.dynamicRoles));
        }
    }, {
        key: 'dynamicRoles',
        get: function get() {

            return [RBAC.ROLE_SERVICE, RBAC.ROLE_OWNER, RBAC.ROLE_CO_OWNER, RBAC.ROLE_COLLABORATOR];
        }
    }, {
        key: 'staticRoles',
        get: function get() {

            return [RBAC.ROLE_SUPER_ADMIN, RBAC.ROLE_MANDATE_PRINT_PDF, RBAC.ROLE_MANDATE_SEND_EDOC, RBAC.ROLE_PROPERTY, RBAC.ROLE_PROPERTY_READ_ONLY, RBAC.ROLE_ADMIN_PROPERTY_BROCHURE, RBAC.ROLE_ADMIN_PROPERTY_CATEGORIES, RBAC.ROLE_ADMIN_PROPERTY_FEATURES, RBAC.ROLE_ADMIN_PROPERTY_TYPES, RBAC.ROLE_ADMIN_PROPERTY_DOCUMENT_TYPE, RBAC.ROLE_ADMIN_USER, RBAC.ROLE_ADMIN_GROUPS, RBAC.ROLE_MANDATE, RBAC.ROLE_MANDATE_READ_ONLY, RBAC.ROLE_ADMIN_MANDATE_COMMISSION, RBAC.ROLE_ADMIN_MANDATE_TEMPLATE, RBAC.ROLE_ADMIN_MANDATE_TYPE, RBAC.ROLE_ADMIN_MANDATE_DOCUMENT_TYPE, RBAC.ROLE_LEAD, RBAC.ROLE_CLIENT, RBAC.ROLE_CLIENT_READ_ONLY, RBAC.ROLE_ADMIN_CLIENT_FLAGS, RBAC.ROLE_ADMIN_CLIENT_DOCUMENT_TYPE, RBAC.ROLE_ADMIN_COMPANY_DOCUMENT_TYPE, RBAC.ROLE_APPOINTMENT, RBAC.ROLE_ADMIN_INBOUND, RBAC.ROLE_ADMIN_AUDIT, RBAC.ROLE_ADMIN_ACL, RBAC.ROLE_ADMIN_THREAD_LABEL, RBAC.ROLE_ADMIN_THREAD_TEMPLATE, RBAC.ROLE_ADMIN_AUTHENTICATION, RBAC.ROLE_ADMIN_COMMERCIALISATION, RBAC.ROLE_ADMIN_FEED, RBAC.ROLE_ADMIN_DOCUSIGN, RBAC.ROLE_ADMIN_OFFER_TEMPLATE, RBAC.ROLE_ADMIN_BDV_TEMPLATE, RBAC.ROLE_ADMIN_APPOINTMENT_TEMPLATE, RBAC.ROLE_ADMIN_SEARCH_TEMPLATE, RBAC.ROLE_ADMIN_AGENCY, RBAC.ROLE_ADMIN_PUBLICATION, RBAC.ROLE_ADMIN_PARTNER, RBAC.ROLE_ADMIN_TIMEMACHINE, RBAC.ROLE_EMANDATE, RBAC.ROLE_COMMERCIALISATION, RBAC.ROLE_COMMERCIALISATION_READ_ONLY, RBAC.ROLE_APPORTEUR, RBAC.ROLE_PROPERTY_PROOFREADER, RBAC.ROLE_ADMIN_CLIENT_TEMPLATE];
        }
    }, {
        key: 'ROLE_PROPERTY_PROOFREADER',
        get: function get() {

            return 'property_proofreader';
        }
    }, {
        key: 'ROLE_ADMIN_CLIENT_TEMPLATE',
        get: function get() {

            return 'admin_client_template';
        }
    }, {
        key: 'ROLE_APPORTEUR',
        get: function get() {

            return 'apporteur';
        }
    }, {
        key: 'ROLE_SERVICE',
        get: function get() {

            return 'service';
        }
    }, {
        key: 'ROLE_OWNER',
        get: function get() {

            return 'owner';
        }
    }, {
        key: 'ROLE_CO_OWNER',
        get: function get() {

            return 'coOwner';
        }
    }, {
        key: 'ROLE_COLLABORATOR',
        get: function get() {

            return 'collaborator';
        }
    }, {
        key: 'ROLE_SUPER_ADMIN',
        get: function get() {

            return 'super_admin';
        }
    }, {
        key: 'ROLE_MANDATE_PRINT_PDF',
        get: function get() {

            return 'mandate_print_pdf';
        }
    }, {
        key: 'ROLE_MANDATE_SEND_EDOC',
        get: function get() {

            return 'mandate_send_edoc';
        }
    }, {
        key: 'ROLE_PROPERTY',
        get: function get() {

            return 'property';
        }
    }, {
        key: 'ROLE_PROPERTY_READ_ONLY',
        get: function get() {

            return 'property_read_only';
        }
    }, {
        key: 'ROLE_ADMIN_PROPERTY_BROCHURE',
        get: function get() {

            return 'admin_property_brochure';
        }
    }, {
        key: 'ROLE_ADMIN_PROPERTY_CATEGORIES',
        get: function get() {

            return 'admin_property_categories';
        }
    }, {
        key: 'ROLE_ADMIN_PROPERTY_FEATURES',
        get: function get() {

            return 'admin_property_features';
        }
    }, {
        key: 'ROLE_ADMIN_PROPERTY_TYPES',
        get: function get() {

            return 'admin_property_types';
        }
    }, {
        key: 'ROLE_ADMIN_PROPERTY_DOCUMENT_TYPE',
        get: function get() {

            return 'admin_property_document_type';
        }
    }, {
        key: 'ROLE_ADMIN_USER',
        get: function get() {

            return 'admin_user';
        }
    }, {
        key: 'ROLE_ADMIN_GROUPS',
        get: function get() {

            return 'admin_groups';
        }
    }, {
        key: 'ROLE_MANDATE',
        get: function get() {

            return 'mandate';
        }
    }, {
        key: 'ROLE_MANDATE_READ_ONLY',
        get: function get() {

            return 'mandate_read_only';
        }
    }, {
        key: 'ROLE_ADMIN_MANDATE_COMMISSION',
        get: function get() {

            return 'admin_mandate_commission';
        }
    }, {
        key: 'ROLE_ADMIN_MANDATE_TEMPLATE',
        get: function get() {

            return 'admin_mandate_template';
        }
    }, {
        key: 'ROLE_ADMIN_MANDATE_TYPE',
        get: function get() {

            return 'admin_mandate_type';
        }
    }, {
        key: 'ROLE_ADMIN_MANDATE_DOCUMENT_TYPE',
        get: function get() {

            return 'admin_mandate_document_type';
        }
    }, {
        key: 'ROLE_LEAD',
        get: function get() {

            return 'lead';
        }
    }, {
        key: 'ROLE_CLIENT',
        get: function get() {

            return 'client';
        }
    }, {
        key: 'ROLE_CLIENT_READ_ONLY',
        get: function get() {

            return 'client_read_only';
        }
    }, {
        key: 'ROLE_ADMIN_CLIENT_FLAGS',
        get: function get() {

            return 'admin_client_flags';
        }
    }, {
        key: 'ROLE_ADMIN_CLIENT_DOCUMENT_TYPE',
        get: function get() {

            return 'admin_client_document_type';
        }
    }, {
        key: 'ROLE_ADMIN_COMPANY_DOCUMENT_TYPE',
        get: function get() {

            return 'admin_company_document_type';
        }
    }, {
        key: 'ROLE_APPOINTMENT',
        get: function get() {

            return 'appointment';
        }
    }, {
        key: 'ROLE_ADMIN_INBOUND',
        get: function get() {

            return 'admin_inbound';
        }
    }, {
        key: 'ROLE_ADMIN_AUDIT',
        get: function get() {

            return 'admin_audit';
        }
    }, {
        key: 'ROLE_ADMIN_ACL',
        get: function get() {

            return 'admin_acl';
        }
    }, {
        key: 'ROLE_ADMIN_THREAD_LABEL',
        get: function get() {

            return 'admin_thread_label';
        }
    }, {
        key: 'ROLE_ADMIN_THREAD_TEMPLATE',
        get: function get() {

            return 'admin_thread_template';
        }
    }, {
        key: 'ROLE_ADMIN_AUTHENTICATION',
        get: function get() {

            return 'admin_authentication';
        }
    }, {
        key: 'ROLE_ADMIN_COMMERCIALISATION',
        get: function get() {

            return 'admin_commercialisation';
        }
    }, {
        key: 'ROLE_ADMIN_FEED',
        get: function get() {

            return 'admin_feed';
        }
    }, {
        key: 'ROLE_ADMIN_DOCUSIGN',
        get: function get() {

            return 'admin_docusign';
        }
    }, {
        key: 'ROLE_ADMIN_OFFER_TEMPLATE',
        get: function get() {

            return 'admin_offer_template';
        }
    }, {
        key: 'ROLE_ADMIN_BDV_TEMPLATE',
        get: function get() {

            return 'admin_bdv_template';
        }
    }, {
        key: 'ROLE_ADMIN_APPOINTMENT_TEMPLATE',
        get: function get() {

            return 'admin_appointment_template';
        }
    }, {
        key: 'ROLE_ADMIN_SEARCH_TEMPLATE',
        get: function get() {

            return 'admin_search_template';
        }
    }, {
        key: 'ROLE_ADMIN_AGENCY',
        get: function get() {

            return 'admin_agency';
        }
    }, {
        key: 'ROLE_ADMIN_PUBLICATION',
        get: function get() {

            return 'admin_publication';
        }
    }, {
        key: 'ROLE_ADMIN_PARTNER',
        get: function get() {

            return 'admin_partner';
        }
    }, {
        key: 'ROLE_ADMIN_TIMEMACHINE',
        get: function get() {

            return 'admin_timemachine';
        }
    }, {
        key: 'ROLE_EMANDATE',
        get: function get() {

            return 'emandate';
        }
    }, {
        key: 'ROLE_COMMERCIALISATION',
        get: function get() {

            return 'commercialisation';
        }
    }, {
        key: 'ROLE_COMMERCIALISATION_READ_ONLY',
        get: function get() {

            return 'commercialisation_read_only';
        }
    }, {
        key: 'managedTypes',
        get: function get() {

            return [RBAC.TYPE_AC, RBAC.TYPE_COACH, RBAC.TYPE_REQUEST, RBAC.TYPE_AREA, RBAC.TYPE_FEED];
        }
    }, {
        key: 'TYPE_AC',
        get: function get() {

            return 'AC';
        }
    }, {
        key: 'TYPE_COACH',
        get: function get() {

            return 'coach';
        }
    }, {
        key: 'TYPE_REQUEST',
        get: function get() {

            return 'request';
        }
    }, {
        key: 'TYPE_AREA',
        get: function get() {

            return 'area';
        }
    }, {
        key: 'TYPE_FEED',
        get: function get() {

            return 'feed';
        }
    }]);

    return RBAC;
}();

internals.dynamicRoles = (_internals$dynamicRol = {}, _defineProperty(_internals$dynamicRol, RBAC.ROLE_SERVICE, function (user) {

    return user.service === true;
}), _defineProperty(_internals$dynamicRol, RBAC.ROLE_OWNER, function (user, asset) {

    return user.id === asset.owner;
}), _defineProperty(_internals$dynamicRol, RBAC.ROLE_CO_OWNER, function (user, asset) {

    return internals.calculate(user, asset.coOwners);
}), _defineProperty(_internals$dynamicRol, RBAC.ROLE_COLLABORATOR, function (user, asset) {

    return internals.calculate(user, asset.collaborators);
}), _internals$dynamicRol);

module.exports = RBAC;